const VISIBILITY_CHANGE_EVENT = 'visibilitychange',
  BEFORE_UNLOAD_EVENT = 'beforeunload';

export { BEFORE_UNLOAD_EVENT, VISIBILITY_CHANGE_EVENT };
